import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import TableWithSummary from './TableWithSummary/TableWithSummary';
import { fuelColumns, getFuelData } from './MainEngineFuelTable';

export const fuelTableHeight = '300px';

const MainGeneratorFuelTable = ({
  mainGeneratorFuel,
  fuelTypes,
  isLoading,
  voyagePortCalls = [],
  segmentedPortCalls = []
}) => {
  const [data, setData] = useState([]);

  useEffect(() => {
    const mappedData = mainGeneratorFuel.map((fuel, index) => {
      return getFuelData(
        fuelTypes[fuel.fuelTypeId],
        fuel,
        voyagePortCalls,
        segmentedPortCalls[index]
      );
    });

    setData(mappedData);
  }, [mainGeneratorFuel, voyagePortCalls, segmentedPortCalls]);

  return (
    <TableWithSummary
      title="Main generator fuel"
      columns={fuelColumns}
      data={data}
      minTableHeight={fuelTableHeight}
      maxTableHeight={fuelTableHeight}
      isLoading={isLoading}
      id="main-generator-fuel-table"
    />
  );
};

MainGeneratorFuelTable.propTypes = {
  mainGeneratorFuel: PropTypes.array,
  fuelTypes: PropTypes.object,
  isLoading: PropTypes.bool,
  voyagePortCalls: PropTypes.arrayOf(PropTypes.object),
  segmentedPortCalls: PropTypes.arrayOf(PropTypes.object)
};

export default MainGeneratorFuelTable;
